
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_gwq0h_a2gwb_13",
  "expand-button": "awsui_expand-button_gwq0h_a2gwb_48",
  "icon": "awsui_icon_gwq0h_a2gwb_52",
  "expanded": "awsui_expanded_gwq0h_a2gwb_67",
  "icon-position": "awsui_icon-position_gwq0h_a2gwb_77",
  "icon-container": "awsui_icon-container_gwq0h_a2gwb_84",
  "icon-container-container": "awsui_icon-container-container_gwq0h_a2gwb_88",
  "wrapper": "awsui_wrapper_gwq0h_a2gwb_101",
  "wrapper-default": "awsui_wrapper-default_gwq0h_a2gwb_109",
  "wrapper-inline": "awsui_wrapper-inline_gwq0h_a2gwb_109",
  "wrapper-footer": "awsui_wrapper-footer_gwq0h_a2gwb_109",
  "wrapper-navigation": "awsui_wrapper-navigation_gwq0h_a2gwb_113",
  "wrapper-container": "awsui_wrapper-container_gwq0h_a2gwb_116",
  "wrapper-compact": "awsui_wrapper-compact_gwq0h_a2gwb_120",
  "header-deprecated": "awsui_header-deprecated_gwq0h_a2gwb_133",
  "wrapper-expanded": "awsui_wrapper-expanded_gwq0h_a2gwb_152",
  "wrapper-not-expanded-without-actions": "awsui_wrapper-not-expanded-without-actions_gwq0h_a2gwb_197",
  "header": "awsui_header_gwq0h_a2gwb_133",
  "header-wrapper": "awsui_header-wrapper_gwq0h_a2gwb_217",
  "header-actions-wrapper": "awsui_header-actions-wrapper_gwq0h_a2gwb_229",
  "header-button": "awsui_header-button_gwq0h_a2gwb_237",
  "header-container-button": "awsui_header-container-button_gwq0h_a2gwb_237",
  "header-button-icon-end": "awsui_header-button-icon-end_gwq0h_a2gwb_266",
  "header-container": "awsui_header-container_gwq0h_a2gwb_237",
  "header-navigation": "awsui_header-navigation_gwq0h_a2gwb_275",
  "icon-container-end": "awsui_icon-container-end_gwq0h_a2gwb_288",
  "header-text": "awsui_header-text_gwq0h_a2gwb_328",
  "content": "awsui_content_gwq0h_a2gwb_338",
  "content-expanded": "awsui_content-expanded_gwq0h_a2gwb_341",
  "content-compact": "awsui_content-compact_gwq0h_a2gwb_344",
  "content-inner": "awsui_content-inner_gwq0h_a2gwb_377",
  "content-inner-expanded": "awsui_content-inner-expanded_gwq0h_a2gwb_399",
  "content-inner-settled": "awsui_content-inner-settled_gwq0h_a2gwb_418",
  "content-inner-body-default": "awsui_content-inner-body-default_gwq0h_a2gwb_426",
  "content-inner-body-inline": "awsui_content-inner-body-inline_gwq0h_a2gwb_426",
  "content-inner-body-footer": "awsui_content-inner-body-footer_gwq0h_a2gwb_429",
  "content-inner-body-container": "awsui_content-inner-body-container_gwq0h_a2gwb_432",
  "disable-header-paddings": "awsui_disable-header-paddings_gwq0h_a2gwb_437",
  "disable-content-paddings": "awsui_disable-content-paddings_gwq0h_a2gwb_442",
  "focusable": "awsui_focusable_gwq0h_a2gwb_447",
  "click-target": "awsui_click-target_gwq0h_a2gwb_462",
  "header-icon-end": "awsui_header-icon-end_gwq0h_a2gwb_469",
  "header-icon-end-with-info": "awsui_header-icon-end-with-info_gwq0h_a2gwb_477",
  "header-content": "awsui_header-content_gwq0h_a2gwb_554",
  "header-content-with-info": "awsui_header-content-with-info_gwq0h_a2gwb_558",
  "header-navigation-content": "awsui_header-navigation-content_gwq0h_a2gwb_564"
};
  